var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 43C11.7964 43 10.4822 42.641 9.51328 42.002C8.54434 41.363 8 40.4963 8 39.5926V20C8 20.6778 8.40826 21.3278 9.13496 21.807C9.86166 22.2863 10.8473 22.5556 11.875 22.5556H37.7083C38.0509 22.5556 38.3794 22.6453 38.6217 22.8051C38.8639 22.9648 39 23.1815 39 23.4074V42.1481C39 42.3741 38.8639 42.5907 38.6217 42.7505C38.3794 42.9103 38.0509 43 37.7083 43H13.1667Z",
    fill: "white",
    stroke: "#DC517C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1006_68646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.375 41.8437H14.0937C13.1738 41.8437 12.2915 41.4783 11.641 40.8278C10.9905 40.1773 10.625 39.295 10.625 38.375",
    stroke: "black",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.25 7.15625C14.0234 7.15625 12.847 7.64353 11.9796 8.51088C11.1123 9.37824 10.625 10.5546 10.625 11.7812V38.375C10.625 37.455 10.9905 36.5727 11.641 35.9222C12.2915 35.2717 13.1738 34.9062 14.0938 34.9062H37.2188C37.5254 34.9062 37.8195 34.7844 38.0363 34.5676C38.2532 34.3508 38.375 34.0567 38.375 33.75V8.3125C38.375 8.00584 38.2532 7.71175 38.0363 7.49491C37.8195 7.27807 37.5254 7.15625 37.2188 7.15625H15.25Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0625 41.8437V34.9062",
    stroke: "black",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5625 16.9844V26.0987C17.5623 26.2958 17.6126 26.4896 17.7085 26.6617C17.8045 26.8339 17.9428 26.9786 18.1105 27.0821C18.2782 27.1856 18.4696 27.2445 18.6664 27.2532C18.8633 27.2619 19.0591 27.22 19.2352 27.1316L31.4375 21.0313L19.1628 15.9175C18.9871 15.8441 18.7961 15.8152 18.6066 15.8334C18.4171 15.8517 18.2351 15.9165 18.0767 16.0221C17.9183 16.1277 17.7885 16.2708 17.6988 16.4387C17.6091 16.6066 17.5622 16.794 17.5625 16.9844Z",
    fill: "#F9E5EC",
    stroke: "black",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1006_68646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.ce107153.svg";
export { ForwardRef as ReactComponent };